/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBubbleMessageAttention: {
  name: 'bubble-message-attention';
  data: string;
} = {
  name: 'bubble-message-attention',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 2A1.5 1.5 0 0 1 2 .5h12A1.5 1.5 0 0 1 15.5 2v10a1.5 1.5 0 0 1-1.5 1.5H4.303a.5.5 0 0 0-.278.084l-2.748 1.832A.5.5 0 0 1 .5 15V2ZM2 1.5a.5.5 0 0 0-.5.5v12.066l1.97-1.314a1.5 1.5 0 0 1 .833-.252H14a.5.5 0 0 0 .5-.5V2a.5.5 0 0 0-.5-.5H2ZM8 3a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0v-5A.5.5 0 0 1 8 3Zm0 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
